module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-lg-10"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-user-circle m-r-sm"
  }), _vm._v(" Account Users\n\n          "), (_vm.editingDifferentUser) ? [_vm._v("/ " + _vm._s(_vm.user.profile.full_name))] : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 col-sm-12 col-lg-2"
  }, [(_vm.canAddAccountUser) ? _c('div', [(_vm.editingDifferentUser) ? _c('div', {
    staticClass: "text-right m-t-lg"
  }, [_c('router-link', {
    staticClass: "material-plus",
    attrs: {
      "to": {
        name: 'account.parent.users.create',
        params: {
          id: this.user.id
        }
      }
    }
  }, [_vm._v("+")])], 1) : _c('div', {
    staticClass: "text-right m-t-lg"
  }, [_c('router-link', {
    staticClass: "material-plus",
    attrs: {
      "to": {
        name: 'account.users.create'
      }
    }
  }, [_vm._v("+")])], 1)]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-583b06be"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/account-users/AccountUsersHeading.vue
// module id = 1009
// module chunks = 0